import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { RouteTravelMode } from "@mapmycustomers/shared/enum/routes/RouteTravelMode";
import { RouteType } from "@mapmycustomers/shared/enum/routes/RouteType";
import { EntitiesSupportingRoutes } from "@mapmycustomers/shared/types/entity";
import Route from "@mapmycustomers/shared/types/entity/Route";

export interface CreateRouteFormPayload {
  name: string;
  routeDetail: {
    allottedTime: number;
    endAddress: string;
    startAddress: string;
    startAt: string;
    travelMode: RouteTravelMode;
    type: RouteType;
  };
}

export const initialize = createAsyncAction(
  "@component/addToRouteModal/initialize/request",
  "@component/addToRouteModal/initialize/success",
  "@component/addToRouteModal/initialize/failure"
)<
  {
    autoAssignOnCreate?: boolean;
    entities: EntitiesSupportingRoutes[];
  },
  {
    routes: Route[];
  },
  void
>();

export const addToRoute = createAsyncAction(
  "@component/addToRouteModal/addToRoute/request",
  "@component/addToRouteModal/addToRoute/success",
  "@component/addToRouteModal/addToRoute/failure"
)<
  {
    callback: (success: boolean) => void;
    entities: EntitiesSupportingRoutes[];
    routeId?: Route["id"];
    showNotification?: boolean;
  },
  void,
  void
>();

export const createRoute = createAsyncAction(
  "@component/addToRouteModal/createRoute/request",
  "@component/addToRouteModal/createRoute/success",
  "@component/addToRouteModal/createRoute/failure"
)<
  {
    callback?: (route: Route) => void;
    route: CreateRouteFormPayload;
  },
  Route,
  void
>();

export const filterRoutes = createAsyncAction(
  "@component/addToRouteModal/filterRoutes/request",
  "@component/addToRouteModal/filterRoutes/success",
  "@component/addToRouteModal/filterRoutes/failure"
)<
  {
    query: string;
  },
  Route[],
  void
>();

export const selectRoute = createAction("@component/addToRouteModal/selectRoute")<
  Route["id"] | undefined
>();

export const showCreateRouteModal = createAction(
  "@component/addToRouteModal/showCreateRouteModal"
)<void>();
export const hideCreateRouteModal = createAction(
  "@component/addToRouteModal/hideCreateRouteModal"
)<void>();

export type Actions = ActionType<
  | typeof addToRoute
  | typeof createRoute
  | typeof filterRoutes
  | typeof hideCreateRouteModal
  | typeof initialize
  | typeof selectRoute
  | typeof showCreateRouteModal
>;
